import { Reviewer, Review } from "@/app/me/[slug]/Mentor/Mentor.schema";

export const getAverageReview = (reviews: Review[]): number =>
  reviews.length > 0 ? calculateAverageReview(reviews) : 0;

export const calculateAverageReview = (reviews: Review[]) =>
  reviews.reduce((acc, cur) => (acc += cur.rating / 2), 0.0) / reviews.length;
